import React, {useState, useCallback} from 'react'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {Modal} from '@thryvlabs/maverick'
import {
  KPGenerateURLComponent,
  KPGenerateBuyNowLink,
} from './kp-11Link-generateUrl'
import {selectedLinkType} from '../../../../app-store/kpGlobalStateSlice'

/* Main button component with modal */
export default function KP11LinkGenerateLinkButtonWithModal({
  selectedCountry,
  cartCentersAndApps,
  transitionData,
  isGenrateLBtnDisabled,
  isInfluencerOps = false,
}) {
  const [generateUrlModalVisibleStatus, setGenerateUrlModalVisibleStatus] =
    useState(false)
  const linkType = useSelector(selectedLinkType)

  return (
    <>
      <button
        className="generate-link-btn"
        disabled={isGenrateLBtnDisabled}
        onClick={() => {
          if (linkType === '1:1' && !isInfluencerOps) {
            if (
              transitionData?.isKickOffApptHasSeoOrTlInCart &&
              !transitionData?.kickOffCallDetails?.isKickOffCallScheduled
            ) {
              toast.error('It seems Kick off call is not been scheduled?')
              return
            }
          }

          setGenerateUrlModalVisibleStatus(true)
          return false
        }}
      >
        Generate Link
      </button>
      {generateUrlModalVisibleStatus && (
        <GenerateLinkModal
          selectedCountry={selectedCountry}
          transitionData={transitionData}
          generateUrlModalVisibleStatus={generateUrlModalVisibleStatus}
          setGenerateUrlModalVisibleStatus={setGenerateUrlModalVisibleStatus}
        />
      )}
    </>
  )
}

const GenerateLinkModal = ({
  selectedCountry,
  generateUrlModalVisibleStatus,
  transitionData,
  setGenerateUrlModalVisibleStatus,
}) => {
  const [generatedLink, setGeneratedLink] = useState('')

  const handleLinkGenerated = useCallback(url => {
    setGeneratedLink(url)
  }, [])

  const handleError = useCallback(() => {
    setGenerateUrlModalVisibleStatus(false)
  }, [setGenerateUrlModalVisibleStatus])

  if (!generateUrlModalVisibleStatus) return null

  // Phase 2: link is ready — show Modal with copy-link UI (no re-generation)
  if (generatedLink) {
    return (
      <Modal
        variant="default"
        btnType="text"
        footer
        hideX={false}
        disableBackdropClick={true}
        primaryFooterVariant="dark"
        openOnLoad
        onClose={() => setGenerateUrlModalVisibleStatus(false)}
      >
        <KPGenerateBuyNowLink generatedBuyNowLink={generatedLink} />
      </Modal>
    )
  }

  // Phase 1: generating — render without Modal so its dialog shell doesn't appear
  // behind the portal spinner. KPGenerateURLComponent's portal handles the overlay.
  return (
    <KPGenerateURLComponent
      selectedCountry={selectedCountry}
      transitionData={transitionData}
      setIsLinkGenerated={() => {}}
      onLinkGenerated={handleLinkGenerated}
      onError={handleError}
    />
  )
}
